<template>
  <b-modal id="driving-license-det" ref="modal" size="lg" title="Detail" @show="setModal" @hidden="resetModal" >
    <b-form >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <div class="form-row">
                <label class="col-md-3">Driving License Type</label>
                <div class="col-md-8 mb-3">
                  {{detail.type_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Registered Name</label>
                <div class="col-md-8 mb-3">
                  {{detail.registered_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Number</label>
                <div class="col-md-8 mb-3">
                  {{detail.registered_number}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Height</label>
                <div class="col-md-8 mb-3">
                  {{detail.height}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Occupation</label>
                <div class="col-md-8 mb-3">
                  {{detail.occupation}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Expiration Date</label>
                <div class="col-md-8 mb-3">
                  {{detail.valid_until}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Description</label>
                <div class="col-md-8 mb-3">
                  {{detail.desc}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status</label>
                <div class="col-md-8 mb-3">
                  {{(detail.status === 1 ? 'Active': 'Non Active')}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <template v-slot:modal-footer>
      <div class="w-100">
        <button class="btn btn-secondary float-right" @click="resetModal"> Cancel </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {BForm, BModal} from 'bootstrap-vue'
export default {
  name: "DrivingLicenseFormDetail",
  components:{
    BForm,
    BModal
  },
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
      detail:{
        type_name:"",
        registered_number:"",
        registered_name:"",
        height:"",
        occupation:"",
        valid_until:"",
        desc:"",
        status:0
      }
    }
  },
  methods:{
    setModal(){
      setTimeout(()=>{
        if (this.data !== null){
          this.detail =this.data
        }
      }, 100)
    },
    resetModal(){
      this.$parent.data = null
      this.$refs.modal.hide()
    }
  }
}
</script>